<template>
  <layout>
    <page-header :header="$t('managers.logs')" :header-small="manager.name" />
    <div class="content">
      <admin-table v-bind="tableProps"></admin-table>
    </div>
  </layout>
</template>

<script>
import { AdminTable } from 'stylemix-vue-admin'
import LogsApi from './LogsApi'
import ManagersApi from './ManagersApi'

export default {
  components: { AdminTable },
  data() {
    // Table resource configuration
    return {
      manager: {},
      tableProps: {
        apiBuilder: () => {
          const { manager_id } = this.$route.params
          return new LogsApi().setParameters({
            id: manager_id,
            context: 'list',
          })
        },

        sortBy: 'created_at',
        sortDesc: true,
        perPage: 30,

        columns: [
          {
            key: 'id',
            label: this.$t('general.id'),
          },
          {
            key: 'description',
            label: this.$t('managers.logging.description'),
          },
          {
            key: 'subject_type',
            label: this.$t('managers.logging.subject'),
          },
          {
            key: 'properties.IP',
            label: this.$t('general.ip'),
          },
          {
            key: 'created_at',
            label: this.$t('general.date'),
            sortable: true,
            formatter: value => {
              return this.$moment(value).format('lll')
            },
          },
        ],

        searchFields: [
          {
            component: 'text-field',
            type: 'search',
            attribute: 'where.description',
            placeholder: this.$t('general.search'),
          },
          {
            component: 'select-field',
            attribute: 'where.subject_type',
            label: this.$t('managers.logging.subject'),
            options: [
              'booking',
              'user',
              'order',
              'company',
              'driver',
              'vehicle',
              'airport',
              'division',
              'zone',
            ].map(subject => ({ label: subject, value: subject })),
          },
        ],

        rowActions: [],
      },
    }
  },

  mounted() {
    new ManagersApi().find(this.$route.params.manager_id).then(result => {
      this.manager = result.data
    })
  },
}
</script>
